import React from 'react';
import styles from '../styles.module.css';
import classNames from 'classnames';
import { type IconType } from '../objects/IconsHelper';

interface IconOptions {
  color?: string;
  className?: string;
  width?: number;
  fillContainer?: boolean;
}

export function svgToIcon(
  svgFile: string,
  { color, className, width, fillContainer }: IconOptions = {}
) {
  // We use this pattern of putting the SVG as inner HTML so that the color
  // of the SVG is controlled by the font color using `currentColor`.

  return (
    <i
      className={classNames('fa-regular', styles.iconSvg, className, {
        [styles.fillContainer]: fillContainer,
      })}
      style={{ color, width }}
      dangerouslySetInnerHTML={{ __html: svgFile }}
    />
  );
}

/** Convert an SVG file to a data url. If passed, replaces currentColor with the provided color */
export function svgToURL(fileContent: string, color?: string) {
  if (color) {
    fileContent = fileContent.replace(/="currentColor"/g, `="${color}"`);
  }

  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(fileContent)}`;
}

interface Offset {
  // proportions of the icon's width/height
  x?: number;
  y?: number;
}

export function svgPathToIcon(
  iconData: IconType,
  options: IconOptions & Offset = {}
) {
  const { d, width, height } = iconData;
  const { color, className, x, y, fillContainer } = options;

  return (
    <i
      className={classNames('fa-regular', styles.iconSvg, className, {
        [styles.fillContainer]: fillContainer,
      })}
      style={{ color }}
    >
      <svg
        style={{
          position: 'relative',
          left: `${(x ?? 0) * 100}%`,
          top: `${(y ?? 0) * 100}%`,
        }}
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path fillRule='evenodd' clipRule='evenodd' d={d} fill='currentColor' />
      </svg>
    </i>
  );
}
